import { withMetadata } from '../metadata'
import { formatIncompletePhoneNumber as _formatIncompletePhoneNumber } from '../../core/index'

export function formatIncompletePhoneNumber() {
	return withMetadata(_formatIncompletePhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/formatIncompletePhoneNumber.js
// module id = XjyP
// module chunks = 0 1